import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import PreviewAdvanceGiven from "./PreviewAdvanceGiven";

const AdvanceGivenCreation = () => {
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [step, setStep] = useState(1);
  const [sra, setSra] = useState();
  const [fileNames, setFileNames] = useState({
    attachment1Filename: "",
    attachment2Filename: "",
    attachment3Filename: "",
  });
  const [fetching, setFetching] = useState(false);
  const { draftSraId } = useParams();
  const location = useLocation();
  const [noOfApprovers, setNoOfApprovers] = useState();
  const [approvers, setApprovers] = useState({
    approver1: "",
    approver2: "",
    approver3: "",
    approver4: "",
  });
  const isClone = location.state?.clone;
  const cloneData = location.state?.data;

  useEffect(() => {
    if (isClone && cloneData) {
      const getSRA = async () => {
        setFetching(true);
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/advance-given/by-id?sraId=${cloneData.id}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
          );
          setSra({
            title: res.data.title || "",
            sapNumber: res.data.sapNumber || "",
            writeType: res.data.writeType || "",
            code: res.data.code || "",
            name: res.data.name || "",
            amount: res.data.amount || "",
            details: res.data.details || "",
            reason: res.data.reason || "",
            impact: res.data.impact || "",
            attachment1: res.data.attachment1 || "",
            attachment2: res.data.attachment2 || "",
            attachment3: res.data.attachment3 || "",
          });
          setNoOfApprovers(res.data.numberOfApprovers);
          setFileNames({
            ...fileNames,
            attachment1Filename: res.data.attachment1Filename || "",
            attachment2Filename: res.data.attachment2Filename || "",
            attachment3Filename: res.data.attachment3Filename || "",
          });
        } catch (error) {
          console.log(error);
        } finally {
          setFetching(false);
        }
      };
      getSRA();
    }
  }, [isClone, cloneData]);

  const getDraft = async () => {
    setFetching(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/draft-advance-given?draftSraId=${draftSraId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
      );
      setSra(res.data);
      setNoOfApprovers(res.data.numberOfApprovers);
      setFileNames({
        ...fileNames,
        attachment1Filename: res.data.attachment1Filename || "",
        attachment2Filename: res.data.attachment2Filename || "",
        attachment3Filename: res.data.attachment3Filename || "",
      });
    } catch (error) {
      console.log(error);
    } finally {
      setFetching(false);
    }
  };
  useEffect(() => {
    if (draftSraId !== undefined) {
      getDraft();
    }
  }, [location]);

  return (
    <div style={{ position: "relative" }}>
      {fetching && <div className="loading-div"></div>}
      {step === 1 && (
        <Step1
          sra={sra}
          setSra={setSra}
          setStep={setStep}
          fileNames={fileNames}
          setFileNames={setFileNames}
          storedUser={storedUser}
        />
      )}
      {step === 2 && (
        <Step2
          sra={sra}
          setSra={setSra}
          setStep={setStep}
          storedUser={storedUser}
        />
      )}
      {step === 3 && (
        <Step3
          sra={sra}
          setSra={setSra}
          setStep={setStep}
          storedUser={storedUser}
          fileNames={fileNames}
          setFileNames={setFileNames}
        />
      )}
      {step === 4 && (
        <Step4
          sra={sra}
          setSra={setSra}
          approvers={approvers}
          setApprovers={setApprovers}
          noOfApprovers={noOfApprovers}
          setNoOfApprovers={setNoOfApprovers}
          setStep={setStep}
          storedUser={storedUser}
        />
      )}

      {step === 5 && (
        <PreviewAdvanceGiven
          sra={sra}
          approvers={approvers}
          setStep={setStep}
          storedUser={storedUser}
          fileNames={fileNames}
          noOfApprovers={noOfApprovers}
        />
      )}
    </div>
  );
};

export default AdvanceGivenCreation;
